import React, { useState, useEffect } from 'react';
import LinkYear from './LinkYear';
import Gallery from './Gallery';
import Technics from './Technics';
import LinkSeries from './LinkSeries';
import { baseUrl } from '../config/config';

function App() {
    const [dataY, setDataY] = useState([]);
    const [dataT, setDataT] = useState([]);
    const [dataG, setDataG] = useState([]);
    const [dataS, setDataS] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedTech, setSelectedTech] = useState(null);
    const [selectedSeries, setSelectedSeries] = useState(null);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isFilterVisible, setIsFilterVisible] = useState(false);

    useEffect(() => {
        fetchDataY();
        fetchDataT();
        fetchDataG();
        fetchDataS();
    }, []);

    const fetchDataY = async () => {
        const response = await fetch(`${baseUrl}apics/api-year.php`);
        const jsonData = await response.json();
        setDataY(jsonData);
    };

    const fetchDataT = async () => {
        const response = await fetch(`${baseUrl}apics/api-tech.php`);
        const jsonData = await response.json();
        setDataT(jsonData);
    };

    const fetchDataG = async () => {
        const response = await fetch(`${baseUrl}apics/api-list.php`);
        const jsonData = await response.json();
        setDataG(jsonData);
    };

    const fetchDataS = async () => {
        const response = await fetch(`${baseUrl}apics/api-series.php`);
        const jsonData = await response.json();
        setDataS(jsonData);
    };

    const handleYearChange = (year) => {
        setSelectedYear(year);
    };

    const handleTechChange = (tech) => {
        setSelectedTech(tech);
    };

    const handleSeriesChange = (series) => {
        setSelectedSeries(series);
    };

    const resetAllFilters = () => {
        setSelectedYear(null);
        setSelectedTech(null);
        setSelectedSeries(null);
    };

    const toggleFilter = () => {
        if (isFilterOpen) {
            closeFilter();
        } else {
            setIsFilterVisible(true);
            // Небольшая задержка для корректного старта анимации
            setTimeout(() => {
                setIsFilterOpen(true);
            }, 10);
        }
    };

    const closeFilter = () => {
        setIsFilterOpen(false);
        // Ждем завершения анимации перед скрытием
        setTimeout(() => {
            setIsFilterVisible(false);
        }, 300);
    };

    return (
        <div>
            <h1>Paintings
                <span onClick={toggleFilter}>Parameters</span>
            </h1>
            
            {isFilterVisible && (
                <div 
                    className={`filter-up ${isFilterOpen ? 'filter-open' : ''}`}
                >
                    <button onClick={closeFilter}>×</button>
                    <div className="filter-content">
                        <LinkYear 
                            data={dataY} 
                            selectedYear={selectedYear}
                            onYearChange={handleYearChange} 
                        />
                        <Technics 
                            data={dataT} 
                            selectedTech={selectedTech} 
                            onTechChange={handleTechChange} 
                        />
                        <LinkSeries 
                            data={dataS} 
                            selectedSeries={selectedSeries}
                            onSeriesChange={handleSeriesChange} 
                        />
                        <div className="filt-all" onClick={resetAllFilters}>
                            Сбросить все
                        </div>
                    </div>
                </div>
            )}
            
            <div className='content'>
                <Gallery data={dataG} selectedYear={selectedYear} selectedTech={selectedTech} selectedSeries={selectedSeries} />
            </div>
        </div>
    );
}

export default App;